// extracted by mini-css-extract-plugin
module.exports =  {"card":"card_xDSkpXdR","templateCard":"templateCard_aB4uv_v1","templateTitle":"templateTitle_KCJQIy_9"};